import api from "../../system/api";
import {getStorage} from "../../system/storage";

// A goal's progress source and chart (backend: src/goals/progress.ts in zofino-strapi; docs/tasks/28-goal-progress-source.md).
const data = (response) => response?.data?.data;
const config = () => ({headers: {workspace: getStorage("workspace")}, suppressGlobalErrorHandler: true});

export const goalProgressApi = {
    get: async (goal) => data(await api.get(`/goal-progress/${goal}`, config())),
    // {source, projectMeasure, manual: {unit, decimals, start, target, current}, reminder: {enabled, frequency}}
    saveSettings: async (goal, settings) => data(await api.put(`/goal-progress/${goal}/settings`, {data: settings}, config())),
    // «به‌روزرسانی پیشرفت»: {value, date}
    addEntry: async (goal, entry) => data(await api.post(`/goal-progress/${goal}/entries`, {data: entry}, config())),
};
